import AuthLoginForm from 'common/components/AuthLoginForm';
import AuthSignupForm from 'common/components/AuthSignupForm';
import Button from 'common/components/Button';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export interface AuthFormProps {
    onSuccess: () => void;
    source?: string;
    email?: string;
    showLogin?: boolean;
    signupHeading?: React.ReactNode;
    signupMessage?: React.ReactNode;
    loginHeading?: React.ReactNode;
    loginMessage?: React.ReactNode;
}

interface FormProps {
    title: React.ReactNode;
    onSuccess: () => string;
    email: string;
    onError?: () => null;
    source?: string;
}

interface AuthFormState {
    form: new (props: FormProps) => AuthLoginForm | AuthSignupForm;
}

class AuthForm extends React.Component<AuthFormProps, AuthFormState> {
    constructor(props: AuthFormProps) {
        super(props);
        this.state = {
            form: this.props.showLogin ? AuthLoginForm : AuthSignupForm,
        };
    }

    render() {
        const { onSuccess, email, source } = this.props;
        const Form = this.state.form;
        return (
            <Form
                title={this.renderTitle()}
                onSuccess={onSuccess}
                email={email || ''}
                source={source}
            />
        );
    }

    renderTitle() {
        if (this.state.form === AuthLoginForm) {
            return (
                <div>
                    <div className="heading heading--with-divider heading--h3">
                        {this.props.loginHeading || <FormattedMessage id="auth_modal.login" />}
                    </div>
                    <div className="paragraph paragraph--soft">
                        <p>{this.props.loginMessage}</p>
                        <FormattedMessage id="auth_modal.no_account" />
                        <Button onClick={this.toggleForm} variation="link" typeAttribute="button">
                            <FormattedMessage id="auth_modal.sign_up" />
                        </Button>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className="heading heading--with-divider heading--h3">
                        {this.props.signupHeading || <FormattedMessage id="auth_modal.sign_up" />}
                    </div>
                    <div className="paragraph paragraph--soft">
                        <p>{this.props.signupMessage}</p>
                        <FormattedMessage id="auth_modal.existing_account" />{' '}
                        <Button onClick={this.toggleForm} variation="link" typeAttribute="button">
                            <FormattedMessage id="auth_modal.login" />
                        </Button>
                    </div>
                </div>
            );
        }
    }

    toggleForm = () =>
        this.setState({ form: this.state.form === AuthLoginForm ? AuthSignupForm : AuthLoginForm });
}
export default AuthForm;



// WEBPACK FOOTER //
// ./js/common/components/AuthForm.tsx